<template>
  <div class="ArtistAbout mb-12">
    <div class="row">
      <div class="col-md-8">
        <div class="ArtistAbout-Bio ArtistAbout-Bio--paragraphs" v-html="artist.full_bio" />
        <ArtistMoreArt class="ArtistAbout-Art--top" />
      </div>
      <div class="col-md-4">
        <div class="ArtistAbout-Prizes mb-10" v-if="artist.prizes.length > 0">
          <h3>Prizes</h3>
          <ArtistPrizes :artist="artist" class="mt-5" />
        </div>
        <div class="ArtistAbout-Exhibitions mb-10" v-if="artist.exhibitions.length > 0 || artist.old_exhibitions">
          <h3>Exhibitions</h3>
          <div class="mt-5" v-if="artist.exhibitions">
            <div
              class="ArtistAbout-ExhibitionItem mt-1"
              :class="{ showMore: index > 2 }"
              v-for="(exhibition, index) in artist.exhibitions"
            >
              <span>{{ exhibition.year }}</span>
              <br />
              <span>{{ exhibition.name }}, {{ exhibition.gallery_name }}</span>
            </div>
          </div>
          <div class="ArtistAbout-ShowMoreLink mt-5" v-if="artist.exhibitions.length > 3">
            <a href="" @click.prevent="toogleDisplayMoreExhibitions">Show more...</a>
          </div>
          <div class="mt-5" v-if="artist.exhibitions.length == 0 && artist.old_exhibitions">
            {{ artist.old_exhibitions }}
          </div>
        </div>
        <div class="ArtistAbout-Education mb-10" v-if="artist.education.length > 0 || artist.old_education">
          <h3>Education</h3>
          <div class="mt-5" v-if="artist.education">
            <div
              class="ArtistAbout-EducationItem mt-1"
              :class="{ showMore: index > 2 }"
              v-for="(education, index) in artist.education"
            >
              <span>{{ education.year }}</span>
              <br />
              <span>{{ education.degree }}, {{ education.university }}</span>
            </div>
          </div>
          <div class="ArtistAbout-ShowMoreLink mt-5" v-if="artist.education.length > 3">
            <a href="" @click.prevent="toogleDisplayMoreEducation">Show more...</a>
          </div>
          <div class="mt-5" v-if="artist.education.length == 0 && artist.old_education">{{ artist.old_education }}</div>
        </div>
        <div class="ArtistAbout-ReachOut">
          <h3>Reach out to {{ artist.first_name }}</h3>
          <div class="mt-5">
            Do you have a question about an artwork for sale?
            <br /><br />
            {{ artist.first_name }}'s studio is in {{ artist.location }}.
          </div>
        </div>
        <a
          :href="artist.conversation_path"
          data-toggle="modal"
          data-target="#conversation-modal"
          data-remote="true"
          class="ProfileEnquireBtn mt-10 btn btn-outline-blue text-uppercase"
        >
          Ask about a Commission
        </a>
        <ArtistMoreArt class="ArtistAbout-Art--bottom" />
      </div>
    </div>
  </div>
</template>

<script setup>
import ArtistPrizes from "./ArtistPrizes.vue"
import ArtistMoreArt from "./ArtistMoreArt.vue"

import { inject } from "vue"

const artist = inject("artist")

const toogleDisplayMoreExhibitions = () => {
  $(".ArtistAbout-ExhibitionItem.showMore").toggle()
  $(".ArtistAbout-Exhibitions").find(".ArtistAbout-ShowMoreLink").toggle()
}
const toogleDisplayMoreEducation = () => {
  $(".ArtistAbout-EducationItem.showMore").toggle()
  $(".ArtistAbout-Education").find(".ArtistAbout-ShowMoreLink").toggle()
}
</script>

<script>
export default {
  name: "ArtistAbout",
}
</script>

<style lang="scss" scoped>
/* purgecss start ignore */
.ArtistAbout {
  font-family: "Lato";
  margin-top: 40px;
  font-size: 14px;

  h3 {
    font-size: 24px;
  }

  .showMore {
    display: none;
  }

  .ProfileEnquireBtn {
    width: 100%;
    padding: 17px 15px 17px 15px;
    font-weight: bold;
    font-size: 12px;
    letter-spacing: 2px;
    line-height: 17px;
  }

  &-Bio {
    font-size: 16px;
    text-align: left;
  }

  &-ShowMoreLink {
    font-size: 16px;
  }

  &-Art--top {
    @media screen and (max-width: theme("screens.md") - 1px) {
      display: none;
    }
  }
  &-Art--bottom {
    @media (min-width: 992px) {
      display: none;
    }
  }
}
</style>
